import { mapGetters } from "vuex";
import { GET_LOAN_CHART_MODEL } from "../helpers/vuex-constants";

import {
  DurationType,
  GrowthIndex,
  DATETYPE,
  AdvanceFilter,
  DefaultRetirementDate,
  ChartTypeDropDownValues,
  ChartViewDropDownValues,
} from "../helpers/constant";
import { CommonHelper } from "../helpers";
import {
  SET_LOAN_CHART_MODEL,
  GET_CLIENT_INFORMATION,
  SET_LOADER_VISIBILITY,
} from "../helpers/vuex-constants";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      selectedComponent: "",
      chartContainer: "chart-container",
      selectedChartComponent: "chart-area",
      selectedFirstChartComponent: "chart-area",
      chartProperties: {},
      chartGraphData: [],
      contentInfo: {
        chartTabContent: [
          {
            text: "Balance",
            id: "chart-area",
            active: true,
          },
          {
            text: "Repayments",
            id: "chart-bar",
            active: false,
          },
          {
            text: "Timeline",
            id: "chart-time-series",
            active: false,
          },
        ],
        chartTabContentTable: [
          {
            text: "Details",
            id: "chart-area",
            active: true,
          },
        ],
      },
      tableSetting: {},
      showTable: false,
    };
  },
  computed: {
    projectionYear() {
      return this.baselineData.projectionYear;
    },
    ...mapGetters("loan", {
      loanChartModel: GET_LOAN_CHART_MODEL,
    }),
    ...mapGetters({
      getClientInformation: GET_CLIENT_INFORMATION,
    }),

    areaChartData() {
      if (this.loanChartModel) return this.loanChartModel.areaChartData.data;
    },
    barChartData() {
      if (this.loanChartModel) return this.loanChartModel.barchartData.data;
    },
    barChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [260, 0],
        tickQuantityY: 5,
        color: ["#1f55af", "#f4c508"],
        legendItems: ["Principal", "Interest"],
        legendKeyType: "bar",
        areaLegendKey: "bar",
        yAxisLabel: "Repayment Amount",
        currencyFormat: ".2s",
        height: 260,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
        domainX: [0, this.loanChartModel.barchartData.maxXAxis],
        domainY: this.getBarChartYAxisData(),
        isHideFirstTick: true,
      };
    },
    areaChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [260, 0],
        tickQuantityY: 5,
        areaLegendItems: "Loan",
        areaLegendKey: "bar",
        lineChartColor: "#2056af",
        currencyFormat: ".2s",
        yAxisLabel: "Loan Balance",
        height: 260,
        axisLeftWidth: 75,
        axisRightWidth: 75,
        domainX: this.getAreaChartXAxisData(),
        domainY: this.getAreaChartYAxisData(),
        tickX: 0,
        isHideFirstTick: true,
      };
    },
    timeSeriesChartProperties() {
      return {
        domainX: this.getTimeSeriesXAxisData(this.baselineData.projectionYear), // [2020, 2055],
        color: ["#e5e5e5", "#1f55af"],
        legendKeyType: "bar",
        height: 10,
        tooltipWidth: 100,
        legendItems: this.legendItems,
        axisLeftWidth: 0,
        axisRightWidth: 0,
      };
    },
  },
  mounted() {
    (this.tableSetting = this.tableViewSettings),
      (this.showTable = false),
      this.onChangeChartTab(this.selectedChartComponent);
  },
  methods: {
    onSelectDataTypeFilter(button, data) {
      button.toggle1 = false;
      this.buttonDataTypeConfig[0].listItems.forEach(
        (m) => (m.isActive = false)
      );
      data.isActive = true;
      button.text = "Chart: " + data.itemText;
      this.showTable = data.itemValue == 3;
    },
    onSelectViewTypeFilter(button, data) {
      button.toggle2 = false;
      this.buttonViewTypeConfig[0].listItems.forEach(
        (m) => (m.isActive = false)
      );
      data.isActive = true;
      button.text = "View: " + data.itemText.slice(0, -5);
      this.showTable = data.itemValue == 3 ? true : false;
    },
    setChartDataTypeDropDown() {
      let chartTypeDropDownValues = [];
      chartTypeDropDownValues = ChartTypeDropDownValues;
      chartTypeDropDownValues.filter(
        (m) => m.itemValue == 1
      )[0].isActive = true;
      this.buttonDataTypeConfig.push({
        text:
          "Chart: " +
          chartTypeDropDownValues.filter((m) => m.itemValue == 1)[0].itemText,
        listItems: [{}],
        filterType: 0,
      });

      this.buttonDataTypeConfig[0].listItems = chartTypeDropDownValues;
    },
    setChartViewTypeDropDown() {
      let chartViewDropDownValues = [];
      chartViewDropDownValues = ChartViewDropDownValues;
      let itemValue = this.showTableView ? 3 : 1;
      chartViewDropDownValues.filter(
        (m) => m.itemValue == itemValue
      )[0].isActive = true;
      this.buttonViewTypeConfig.push({
        text:
          "View: " +
          chartViewDropDownValues
            .filter((m) => m.itemValue == itemValue)[0]
            .itemText.slice(0, -5),
        listItems: [{}],
        filterType: itemValue,
      });

      this.buttonViewTypeConfig[0].listItems = chartViewDropDownValues;
    },
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    startOptionsNew() {
      const client = this.$store.state.root.clientInformation.filter(
        (x) => x.entityType == 1
      )[0];
      const partner = this.$store.state.root.clientInformation.filter(
        (x) => x.entityType == 2
      )[0];
      let data = [
        {
          text: "Start",
          value: DATETYPE.Start,
          meta: "07/2025",
        },
        {
          text: "Start FY",
          value: DATETYPE.Start_Fy,
          meta: "07/2025",
        },
        {
          text: "Max",
          value: DATETYPE.Max,
          meta: "07/2053",
        },
        {
          text: "Client Retirement",
          value: DATETYPE.Client_Retirement,
          meta: CommonHelper.getRetirementMonthAndYear(
            client.dob,
            DefaultRetirementDate
          ),
        },
        {
          text: "Other",
          value: DATETYPE.Other,
          meta: "",
        },
      ];
      if (partner) {
        data.push({
          text: "Partner Retirement",
          value: DATETYPE.Partner_Retirement,
          meta: CommonHelper.getRetirementMonthAndYear(
            partner.dob,
            DefaultRetirementDate
          ),
        });
      }
      return data;
    },
    removeRow() {
      this.getinsertEmptyRows(this.rows);
    },
    onChangeChartTab(tabId) {
      this.chartGraphData = [];
      this.selectedChartComponent = tabId;
      if (this.selectedChartComponent == "chart-area") {
        this.chartProperties = this.areaChartProperties;
        this.chartGraphData = this.areaChartData;
      } else if (this.selectedChartComponent == "chart-bar") {
        this.chartProperties = this.barChartProperties;
        this.chartGraphData = this.barChartData;
      } else {
        this.chartProperties = this.timeSeriesChartProperties;
        this.chartGraphData = this.timeSeriesChartData;
      }
    },

    validatebyrow(row, subtypeid) {
      let Error = true;
      for (
        let i = 0;
        i <
        this.singleHeadingOptions.filter((x) => x.key == subtypeid)[0].fields
          .length;
        i++
      ) {
        let key = this.singleHeadingOptions.filter((x) => x.key == subtypeid)[0]
          .fields[i];
        // let isRequired = this.headers.filter((x) => x.key == key)[0].validation;
        let isNumber = this.headers.filter((x) => x.key == key)[0]
          .isAllowOnlyNumber;

        if (
          // isRequired &&
          (row[key].value != "" && !isNumber) ||
          (row[key].value != "0" && isNumber)
        ) {
          Error = false;
        }
      }
      return Error;
    },
    getinsertEmptyRows(currentRows) {
      if (this.singleHeadingOptions) {
        for (let i = 0; i < this.singleHeadingOptions.length; i++) {
          if (
            currentRows.filter(
              (x) => x.subTypeId.value == this.singleHeadingOptions[i].key
            ).length == 0
          )
            currentRows.push(
              this.fillData(undefined, this.singleHeadingOptions[i].key)
            );
        }
      }
    },
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    scrollBottom() {
      document.querySelector("#advancesettingswrapperdiv").scrollTop =
        document.querySelector("#advancesettingswrapperdiv").clientHeight;
    },
    ResetMonthPickerValue(rows) {
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].EndDate && typeof rows[i].EndDate.value == "object") {
            rows[i].EndDateType.value = rows[i].EndDate.value.value;
            rows[i].EndDate.value = rows[i].EndDate.value.meta;
          }
          if (typeof rows[i].StartDate.value == "object") {
            rows[i].StartDateType.value = rows[i].StartDate.value.value;
            rows[i].StartDate.value = rows[i].StartDate.value.meta;
          }
        }
      }
      return rows;
    },
    AddNewTypeRow(data) {
      let splitid = this.gridSplitId == "" ? 1 : data.key;
      this.focusElementName = "";
      this.rows.push(this.fillData(undefined, data.key));
      let splitRows = this.rows.filter((x) => x.subTypeId.value == data.key);
      let newIndex = splitRows.length - 1;

      let previousEndDate = splitRows[newIndex - 1].EndDate.value.meta
        ? splitRows[newIndex - 1].EndDate.value.meta
        : splitRows[newIndex - 1].EndDate.value;
      if (previousEndDate != "") {
        let nextDate = CommonHelper.getNextDate(previousEndDate);
        let DateData = {
          text: "Other",
          value: DATETYPE.Other,
          meta: nextDate,
        };
        splitRows[newIndex].StartDate.value = DateData;
        let data = this.getUserInputData(this.rows);
        this.rows = this.emptyGridRow(data);
        // this.rows[newIndex].endDate.value.meta = nextDate;
        // this.rows[newIndex].endDate.value.text = "Other";
        // this.rows[newIndex].endDate.value.value = DATETYPE.Other;
      }

      let firstElement =
        this.singleHeadingOptions.filter((x) => x.key == data.key)[0]
          .fields[0] +
        splitid +
        newIndex;
      setTimeout(() => {
        this.focusElementName = firstElement;
        this.scrollBottom();
      }, 100);
      // this.rows.filter((x) => x.subTypeId.value == data.key)[index][DateType][
      //   key
      // ]
    },
    ...mapActions("loan", {
      setLoanChartModel: SET_LOAN_CHART_MODEL,
    }),
    updateDatainRow(index, subtype, key, value, DateType) {
      if (
        this.rows.filter((x) => x.subTypeId.value == subtype)[index][DateType]
      )
        this.rows.filter((x) => x.subTypeId.value == subtype)[index][DateType][
          key
        ] = value;
    },
    setDisabledtemRepayment(repaymentid) {
      let data = {
        Frequency: true,
        Amount: true,
        StartDate: true,
        EndDate: true,
      };
      if (repaymentid == 1 || repaymentid == 2) {
        data.Frequency = true;
        data.Amount = false;
        data.StartDate = true;
        data.EndDate = true;
      } else if (repaymentid == 3) {
        data.Frequency = false;
        data.Amount = false;
        data.StartDate = true;
        data.EndDate = true;
      } else if (repaymentid == 4) {
        data.Frequency = true;
        data.Amount = true;
        data.StartDate = true;
        data.EndDate = true;
      }

      return data;
    },
    OnOptionChange(data) {
      let UpdateKey =
        data.key == "StartDateType"
          ? "StartDate"
          : data.key == "EndDateType"
          ? "EndDate"
          : data.key;
      // if (UpdateKey == "StartDate" || UpdateKey == "EndDate") {
      //   this.focusElementName = "";
      //   // let startMonth = new Date().getMonth() + 1;
      //   // let startYear = new Date().getFullYear();
      //   // if (startMonth < 6) {
      //   //   startYear = startYear - 1;
      //   // }

      //   let ProjectionDate = new Date(this.ProjectionDate);
      //   let startYear = ProjectionDate.getFullYear();

      //   let start = "07/" + startYear;
      //   let currentRows = this.rows;
      //   let index = data.index;
      //   let subtype = data.row.subTypeId.value;
      //   let changedvalue = data.event;

      //   this.updateDatainRow(index, subtype, "value", "", UpdateKey);
      //   this.updateDatainRow(index, subtype, "isShowFocus", false, UpdateKey);
      //   if (changedvalue != DATETYPE.Other) {
      //     this.updateDatainRow(index, subtype, "disable", true, UpdateKey);
      //   } else {
      //     this.updateDatainRow(index, subtype, "disable", false, UpdateKey);
      //     this.updateDatainRow(index, subtype, "isShowFocus", true, UpdateKey);
      //   }
      //   if (
      //     changedvalue == DATETYPE.Start ||
      //     changedvalue == DATETYPE.Start_Fy
      //   ) {
      //     this.updateDatainRow(index, subtype, "value", start, UpdateKey);
      //   }
      //   if (changedvalue == DATETYPE.Client_Retirement) {
      //     let RetirementDate =
      //       this.getClientInformation.filter((x) => x.entityType == 1)[0].dob !=
      //       null
      //         ? new Date(
      //             this.getClientInformation.filter(
      //               (x) => x.entityType == 1
      //             )[0].dob
      //           )
      //         : new Date();
      //     let month = RetirementDate.getMonth() + 1;
      //     let year = RetirementDate.getFullYear() + 65;
      //     let date = ("0" + month).slice(-2) + "/" + year;

      //     this.updateDatainRow(index, subtype, "value", date, UpdateKey);
      //   }
      //   if (changedvalue == DATETYPE.Partner_Retirement) {
      //     let RetirementDate =
      //       this.getClientInformation.filter((x) => x.entityType == 2)[0].dob !=
      //       null
      //         ? new Date(
      //             this.getClientInformation.filter(
      //               (x) => x.entityType == 2
      //             )[0].dob
      //           )
      //         : new Date();
      //     let month = RetirementDate.getMonth() + 1;
      //     let year = RetirementDate.getFullYear() + 65;
      //     let date = ("0" + month).slice(-2) + "/" + year;

      //     this.updateDatainRow(index, subtype, "value", date, UpdateKey);
      //   }
      //   if (changedvalue == DATETYPE.Max) {
      //     let projectionyear = this.projectionYear.Value;
      //     let currentYear = new Date().getFullYear();
      //     let ProjectionDate = "07/" + (currentYear + projectionyear);

      //     this.updateDatainRow(
      //       index,
      //       subtype,
      //       "value",
      //       ProjectionDate,
      //       UpdateKey
      //     );
      //   }
      //   this.rows = currentRows;
      // }
      if (UpdateKey == "RepaymentType") {
        let index = data.index;
        let subtype = data.row.subTypeId.value;
        let changedvalue = data.event;

        // this.updateDatainRow(index, subtype, "disable", false, "endDate");
        let repaymentData = this.setDisabledtemRepayment(changedvalue);
        this.updateDatainRow(
          index,
          subtype,
          "disable",
          !repaymentData.Amount,
          "Amount"
        );
        this.updateDatainRow(
          index,
          subtype,
          "disable",
          !repaymentData.Frequency,
          "Frequency"
        );

        this.resetRow(
          this.rows.filter((x) => x.subTypeId.value == subtype)[index]
        );
      }
    },
    resetRow(row) {
      for (var key of Object.keys(row)) {
        if (
          row[key].value != undefined &&
          key != this.gridSplitId &&
          key != "RepaymentType" &&
          this.headers.filter((x) => x.key == key).length > 0
        ) {
          let headerkey = this.headers.filter((x) => x.key == key)[0].type;
          if (headerkey == "FormatInput" || headerkey == "Dropdown") {
            row[key].value = 0;
          } else {
            row[key].value = "";
          }
        }
      }
    },
    getEloquaFormModel() {
      return {
        entityType: this.baselineFilterObject.entityType,
        loanType: this.baselineFilterObject.loanType,
        openingBalance: this.baselineFilterObject.openingBalance,
        repaymentFrequency: this.baselineFilterObject.repaymentFrequency,
        interestRate: this.baselineFilterObject.interestRate,
        repaymentType: this.baselineFilterObject.repaymentType,
        repaymentAmount: this.baselineFilterObject.repaymentAmount,
        taxDeductibilityPercent:
          this.baselineFilterObject.taxDeductibilityPercent,
        loanTerm: this.baselineFilterObject.loanTerm,
        loanMonth: this.baselineFilterObject.loanMonth,
        description: this.baselineFilterObject.description,
        uniqueId: CommonHelper.uuidv4(),
        advancedetails: this.getAdvanceFilterDetails(),
      };
    },

    getAdvanceFilterDetails() {
      let userEnteredData = [];
      for (
        let i = 0;
        i < this.baselineFilterObject.advancedetails.length;
        i++
      ) {
        let row = this.addICERow(this.baselineFilterObject.advancedetails[i]);
        userEnteredData.push(row);
      }

      return userEnteredData;
    },
    defaultStringValue(element) {
      if (!element) {
        return "";
      } else {
        return element.value;
      }
    },

    defaultIntValue(element) {
      if (!element || element.value == "" || isNaN(element.value)) {
        return 0;
      } else {
        return element.value;
      }
    },
    addICERow(GridRow) {
      let row = {};
      row.typeId = this.defaultIntValue(GridRow.typeId);
      row.subTypeId = this.defaultIntValue(GridRow.subTypeId);
      row.repaymentType = this.defaultIntValue(GridRow.repaymentType);
      row.adjustedTerm = this.defaultIntValue(GridRow.adjustedTerm);
      row.amount = this.defaultIntValue(GridRow.amount);
      row.endDate = this.defaultStringValue(GridRow.endDate);
      row.accountNumber = "";
      row.endDateType = this.defaultIntValue(GridRow.endDateType);
      row.startDate = this.defaultStringValue(GridRow.startDate);
      row.startDateType = this.defaultIntValue(GridRow.startDateType);
      row.index = this.defaultIntValue(GridRow.index);
      row.frequency = this.defaultIntValue(GridRow.frequency);
      row.effectiveAsON = this.defaultIntValue(GridRow.effectiveAsON);
      return row;
    },

    async UpdateGraphByICEApi() {
      this.chartGraphData = [];
      let baselineData = this.getEloquaFormModel();
      baselineData.loanTerm =
        baselineData.loanTerm * 12 + baselineData.loanMonth;
      let apiModel = this.prepareAPIModel(baselineData);
      this.setLoaderVisibility(true);
      const projectionData = await this.getLoanProjection(apiModel);
      this.setLoaderVisibility(false);
      if (projectionData.length == 0) {
        return;
      }
      this.setLoanChartModel(this.setLoanModel(projectionData, baselineData));

      this.setFocus();
    },
    setFocus() {
      let chartContainerElement = this.$el.getElementsByClassName(
        this.chartContainer
      );
      if (chartContainerElement && chartContainerElement.length > 0) {
        chartContainerElement[0].scrollIntoView({ behavior: "smooth" });
      }
    },
    getTimeSeriesXAxisData(projectionYear) {
      let ProjectionDate = new Date(this.ProjectionDate);
      let startYear = ProjectionDate.getFullYear();
      return [startYear, startYear + projectionYear.Value];
    },

    getTimeSeriesCoordinate(addtionalData, filterType, projectionYear) {
      let timeseriesData = [];
      if (addtionalData == null || addtionalData.length == 0) {
        return timeseriesData;
      }
      let userinputdata = addtionalData.filter(
        (sr) => sr.typeId.value == filterType
      );
      let yearRange = this.getTimeSeriesXAxisData(projectionYear);
      if (userinputdata && userinputdata.length > 0) {
        for (let i = 0; i < userinputdata.length; i++) {
          let statYearMonth = this.getStartMonthYear(
            userinputdata[i].startDate.value,
            yearRange
          );
          let endYearMonth = this.getEndMonthYear(
            userinputdata[i].endDate.value,
            yearRange
          );
          timeseriesData.push({
            id: i,
            startMonth: statYearMonth[0],
            startYear: statYearMonth[1],
            endMonth: !endYearMonth ? statYearMonth[0] + 1 : endYearMonth[0],
            endYear: !endYearMonth ? statYearMonth[1] : endYearMonth[1],
            description: userinputdata[i].description.value,
            title: isNaN(userinputdata[i].amount.value)
              ? 0
              : filterType == AdvanceFilter.Interest_Rate
              ? CommonHelper.addConstantSymbolInNumber(
                  userinputdata[i].amount.value,
                  "%"
                )
              : CommonHelper.convertAmountIntoCurrency(
                  userinputdata[i].amount.value
                ),
          });
        }
      }
      return timeseriesData;
    },
    getStartMonthYear(date, yearRange) {
      if (!date || date == "") {
        return [1, yearRange[0]];
      } else {
        let monthrange = date.split("/");
        return [parseInt(monthrange[0]), parseInt(monthrange[1])];
      }
    },
    getEndMonthYear(date) {
      if (!date || date == "") {
        return undefined;
      } else {
        let monthrange = date.split("/");
        return [parseInt(monthrange[0]), parseInt(monthrange[1])];
      }
    },
    getBarChartYAxisData() {
      let roundOffYaxis = 0;
      if (this.loanChartModel) {
        roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
          0,
          Math.ceil(this.loanChartModel.barchartData.maxYAxis),
          5
        );
        if (roundOffYaxis < 5) {
          roundOffYaxis = 5;
        }
        return [0, roundOffYaxis];
      }
    },
    getAreaChartXAxisData() {
      let xAxisArry = [0, this.projectionYear.Value];

      return xAxisArry;
    },
    getAreaChartYAxisData() {
      if (this.loanChartModel) {
        let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
          0,
          Math.ceil(this.loanChartModel.areaChartData.maxYAxis),
          5
        );
        if (roundOffYaxis < 5) {
          roundOffYaxis = 5;
        }
        return [0, roundOffYaxis];
      }
    },

    fillLoanModel(typeId) {
      if (this.baselineFilterObject.advancedetails == null) {
        this.baselineFilterObject.advancedetails = this.getUserInputData(
          this.rows
        );
      } else {
        let data = this.baselineFilterObject.advancedetails.filter(
          (sr) => sr.typeId.value != typeId
        );
        let advancedetails = data.concat(this.getUserInputData(this.rows));
        this.baselineFilterObject.advancedetails = advancedetails;
      }

      this.$emit("resetBaselineData", this.baselineFilterObject);
    },

    IsAnyLoanOptionHaveInvalidData(errorLoanOption) {
      if (errorLoanOption && errorLoanOption.InterestRate.length > 0) {
        this.$emit("openErrorTab", AdvanceFilter.Interest_Rate);
        return true;
      } else if (errorLoanOption && errorLoanOption.Drawdown.length > 0) {
        this.$emit("openErrorTab", AdvanceFilter.DrawDown);
        return true;
      } else if (errorLoanOption && errorLoanOption.Repayment.length > 0) {
        this.$emit("openErrorTab", AdvanceFilter.Repayment);
        return true;
      } else if (errorLoanOption && errorLoanOption.LoanTerm.length > 0) {
        this.$emit("openErrorTab", AdvanceFilter.LoanTerm);
        return true;
      } else {
        return false;
      }
    },
    enableResetButton(isFormChanges, key) {
      let resetButtomIndex = this.gridButtonTemplatedata.findIndex(
        (sr) => sr.key == key
      );
      if (resetButtomIndex >= 0) {
        this.gridButtonTemplatedata[resetButtomIndex].isdisabled =
          isFormChanges;
      }
    },
    SetErrors(row, key, IsError, ErrorText = [""]) {
      row[key].IsError = IsError;
      row[key].ErrorText = ErrorText;
    },
    RemoveError(Errors, typeid) {
      if (typeid == AdvanceFilter.Interest_Rate) {
        Errors["InterestRate"] = [];
      } else if (typeid == AdvanceFilter.Repayment) {
        Errors["Repayment"] = [];
      } else if (typeid == AdvanceFilter.DrawDown) {
        Errors["Drawdown"] = [];
      } else {
        Errors["LoanTerm"] = [];
      }
    },

    PushErrors(Errors, typeid, subType, error) {
      if (typeid == AdvanceFilter.Interest_Rate) {
        if (
          Errors.InterestRate.filter(
            (x) => x.type == subType && x.error == error
          ).length == 0
        )
          Errors.InterestRate.push({
            type: subType,
            error: error,
          });
      } else if (typeid == AdvanceFilter.Repayment) {
        if (
          Errors.Repayment.filter((x) => x.type == subType && x.error == error)
            .length == 0
        )
          Errors.Repayment.push({
            type: subType,
            error: error,
          });
      } else if (typeid == AdvanceFilter.DrawDown) {
        if (
          Errors.Drawdown.filter((x) => x.type == subType && x.error == error)
            .length == 0
        )
          Errors.Drawdown.push({
            type: subType,
            error: error,
          });
      } else {
        if (
          Errors.LoanTerm.filter((x) => x.type == subType && x.error == error)
            .length == 0
        )
          Errors.LoanTerm.push({
            type: subType,
            error: error,
          });
      }
    },
    validations(tabdata, typeid) {
      let fields = this.singleHeadingOptions;
      let headers = this.headers;
      let rows = [];
      rows = tabdata.filter((sr) => sr.typeId.value == typeid);

      // let filteredrows = [];

      let blankdataError = false;
      let hasRangeError = false;

      let Errors = {
        hasErrors: false,
        InterestRate: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.InterestRate
          : [],
        Repayment: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Repayment
          : [],
        Drawdown: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Drawdown
          : [],
        LoanTerm: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.LoanTerm
          : [],
      };
      if (rows.length > 0) {
        //  let overlapvalidations = false;
        // for (let f = 0; f < fields.length; f++) {
        //   filteredrows = rows.filter((x) => x.subTypeId.value == fields[f].key);
        //   overlapvalidations = fields[f].overlapvalidations;
        this.RemoveError(Errors, typeid);

        for (let i = 0; i < rows.length; i++) {
          let subType = rows[i].subTypeId.value;
          let startMonth = "",
            startYear = "",
            endMonth = "",
            endYear = "";
          for (
            let h = 0;
            h < headers.filter((x) => x.type != "Icon").length;
            h++
          ) {
            let headername = CommonHelper.camelCase(headers[h].key);
            if (headername == "startDate") {
              startMonth = CommonHelper.getMonthfromMonthYear(
                rows[i].startDate.value
              );
              startYear = CommonHelper.getYearfromMonthYear(
                rows[i].startDate.value
              );
            }
            if (headername == "endDate") {
              endMonth = CommonHelper.getMonthfromMonthYear(
                rows[i].endDate.value
              );
              endYear = CommonHelper.getYearfromMonthYear(
                rows[i].endDate.value
              );
            }
            if (
              headers[h].validation == true &&
              fields
                .filter((x) => x.key == rows[i].subTypeId.value)[0]
                .fields.filter(
                  (x) => x.toLowerCase() == headername.toLowerCase()
                ).length > 0
            ) {
              if (
                !rows[i][headername].disable &&
                (rows[i][headername].value == "" ||
                  rows[i][headername].value == "0")
              ) {
                blankdataError = true;
                this.SetErrors(rows[i], headername, true);
              } else {
                if (
                  headername == "startDate" &&
                  rows[i].startDateType.value != 0 &&
                  rows[i].startDate.value.length != 7
                ) {
                  Errors.hasErrors = true;
                  blankdataError = true;
                  this.SetErrors(rows[i], headername, true);
                  this.PushErrors(Errors, typeid, subType, "Invalid Date");
                } else if (
                  headername == "endDate" &&
                  rows[i].endDateType.value != 0 &&
                  rows[i].endDate.value.length != 7
                ) {
                  Errors.hasErrors = true;
                  blankdataError = true;
                  this.SetErrors(rows[i], headername, true);
                  this.PushErrors(Errors, typeid, subType, "Invalid Date");
                } else {
                  this.SetErrors(rows[i], headername, false);
                }
              }
            }
          }
          if (blankdataError) {
            let error = "All Fields are Required";
            Errors.hasErrors = true;
            this.PushErrors(Errors, typeid, subType, error);
          }

          startMonth = CommonHelper.getMonthfromMonthYear(
            rows[i].startDate.value
          );
          startYear = CommonHelper.getYearfromMonthYear(
            rows[i].startDate.value
          );
          endMonth = rows[i].endDate
            ? CommonHelper.getMonthfromMonthYear(rows[i].endDate.value)
            : "";
          endYear = rows[i].endDate
            ? CommonHelper.getYearfromMonthYear(rows[i].endDate.value)
            : "";
          if (
            CommonHelper.compareDates(
              startYear,
              startMonth,
              "01",
              endYear,
              endMonth,
              "01"
            ) &&
            !blankdataError &&
            startMonth != "" &&
            endMonth != "" &&
            fields.filter((x) => x.key == rows[i].subTypeId.value)[0]
              .overlapvalidations
          ) {
            Errors.hasErrors = true;
            this.SetErrors(rows[i], "startDate", true);
            this.SetErrors(rows[i], "endDate", true);
            if (!hasRangeError) {
              let Errormsg =
                "Start Date cannot be greater than or equal to End Date";
              this.PushErrors(Errors, typeid, subType, Errormsg);
            }
            hasRangeError = true;
          }
          if (!blankdataError) {
            for (let j = 0; j < rows.length; j++) {
              if (
                i != j &&
                fields.filter((x) => x.key == rows[i].subTypeId.value)[0]
                  .overlapvalidations &&
                fields.filter((x) => x.key == rows[j].subTypeId.value)[0]
                  .overlapvalidations
              ) {
                let err =
                  "Hit 'Tab' to move to the next cell and add a new row";
                if (
                  !CommonHelper.CompareOverlappingDates(
                    startYear,
                    startMonth,
                    "01",
                    endYear,
                    endMonth,
                    "01",
                    CommonHelper.getYearfromMonthYear(rows[j].startDate.value),
                    CommonHelper.getMonthfromMonthYear(rows[j].startDate.value),
                    "01",
                    CommonHelper.getYearfromMonthYear(rows[j].endDate.value),
                    CommonHelper.getMonthfromMonthYear(rows[j].endDate.value),
                    "01"
                  ) &&
                  rows[j].startDate.value != "" &&
                  rows[j].endDate.value != ""
                ) {
                  this.SetErrors(rows[i], "startDate", true);
                  this.SetErrors(rows[i], "endDate", true);
                  Errors.hasErrors = true;
                  err =
                    "Overlapping time frame. To Proceed, review and edit to ensure no overlapping across periods";
                  this.PushErrors(Errors, typeid, subType, err);
                }
              }
            }
          }
        }
        this.infoError = Errors.hasErrors;
        if (Errors.hasErrors) {
          if (typeid == AdvanceFilter.Interest_Rate) {
            this.infoText = Errors.InterestRate.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.InterestRate = this.infoText;
          } else if (typeid == AdvanceFilter.Repayment) {
            this.infoText = Errors.Repayment.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Repayment = this.infoText;
          } else if (typeid == AdvanceFilter.DrawDown) {
            this.infoText = Errors.Drawdown.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Drawdown = this.infoText;
          } else {
            this.infoText = Errors.LoanTerm.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.LoanTerm = this.infoText;
          }
        } else {
          this.RemoveError(Errors, typeid);
          this.infoText = [];
        }
        let data = tabdata.filter((sr) => sr.typeId.value != typeid);
        let advancedetails = data.concat(rows);
        this.baselineFilterObject.advancedetails = advancedetails;
        this.baselineFilterObject.Errors = Errors;
        this.rows = this.emptyGridRow(rows);
        this.focusElementName = "";
        this.setErrorFocus();
      } else {
        this.RemoveError(Errors, typeid);
        this.baselineFilterObject.Errors = Errors;
      }
      this.getinsertEmptyRows(this.rows);

      return Errors.hasErrors;
    },
    checkerror(Row) {
      for (var key of Object.keys(Row)) {
        if (Row[key].IsError == true && Row[key].IsError != undefined) {
          if (key == "StartDate") return "StartDateType";
          if (key == "EndDate") return "EndDateType";

          return key;
        }
      }
      return "";
    },
    setErrorFocus() {
      let firstFocusElement = "";

      for (let i = 0; i < this.singleHeadingOptions.length; i++) {
        let Row = this.rows.filter(
          (x) => x.subTypeId.value == this.singleHeadingOptions[i].key
        );
        for (let l = 0; l < Row.length; l++) {
          let key = this.checkerror(Row[l]);
          if (key != "") {
            firstFocusElement = key + this.singleHeadingOptions[i].key + l;
          }
        }
      }
      this.focusElementName = firstFocusElement;
    },

    addNewRow() {
      this.rows.push(this.emptyGridRow());
      this.scrollBottom();
    },
    addRow(index, subtypeid) {
      this.rows.splice(index + 1, 0, this.fillData(undefined, subtypeid));
      this.focusElementName = "";

      let newIndex =
        this.rows.filter((x) => x.subTypeId.value == subtypeid).length - 1;
      let firstElement =
        this.singleHeadingOptions.filter((x) => x.key == subtypeid)[0]
          .fields[0] +
        subtypeid +
        newIndex;
      setTimeout(() => {
        this.focusElementName = firstElement;
        this.scrollBottom();
      }, 100);
    },
    monthOptions() {
      return [
        {
          text: "01",
          value: "1",
        },
        {
          text: "02",
          value: "2",
        },
        {
          text: "03",
          value: "3",
        },
        {
          text: "04",
          value: "4",
        },
        {
          text: "05",
          value: "5",
        },
        {
          text: "06",
          value: "6",
        },
        {
          text: "07",
          value: "7",
        },
        {
          text: "08",
          value: "8",
        },
        {
          text: "09",
          value: "9",
        },
        {
          text: "10",
          value: "10",
        },
        {
          text: "11",
          value: "11",
        },
        {
          text: "12",
          value: "12",
        },
      ];
    },
    startOptions() {
      return [
        {
          text: "Start",
          value: DATETYPE.Start,
        },
        {
          text: "Start FY",
          value: DATETYPE.Start_Fy,
        },
        {
          text: "Max",
          value: DATETYPE.Max,
        },
        {
          text: "Client Retirement",
          value: DATETYPE.Client_Retirement,
        },
        {
          text: "Partner Retirement",
          value: DATETYPE.Partner_Retirement,
        },
        {
          text: "Other",
          value: DATETYPE.Other,
        },
      ];
    },
    endOptions() {
      return [
        {
          text: "Start",
          value: DATETYPE.Start,
        },
        {
          text: "Start FY",
          value: DATETYPE.Start_Fy,
        },
        {
          text: "Max",
          value: DATETYPE.Max,
        },
        {
          text: "Client Retirement",
          value: DATETYPE.Client_Retirement,
        },
        {
          text: "Partner Retirement",
          value: DATETYPE.Partner_Retirement,
        },
        {
          text: "Other",
          value: DATETYPE.Other,
        },
      ];
    },
    yearOption() {
      let statYear = 2022;
      let yearOptions = [];
      for (let i = statYear; i < statYear + 50; i++) {
        yearOptions.push({ text: i.toString(), value: i.toString() });
      }
      return yearOptions;
    },

    frequencyOption() {
      return [
        {
          text: "Weekly",
          value: DurationType.Weeks,
        },
        {
          text: "Fortnightly",
          value: DurationType.Fortnights,
        },
        {
          text: "Monthly",
          value: DurationType.Months,
        },
        // {
        //   text: "Half Yearly",
        //   value: DurationType.Half_Year,
        // },
        // {
        //   text: "Yearly",
        //   value: DurationType.Years,
        // },
      ];
    },

    indexOptions() {
      return [
        {
          text: "AWOTE",
          value: GrowthIndex.AWOTE,
        },
        {
          text: "CPI",
          value: GrowthIndex.CPI,
        },
        {
          text: "None",
          value: GrowthIndex.NONE,
        },
      ];
    },
    genericMethodClick(function_name, param1, param2) {
      if (function_name) {
        this[function_name](param1, param2);
      }
    },
  },
};
